import { Module, VuexModule, Mutation } from 'vuex-class-modules'

@Module
class UIModule extends VuexModule {
  _backgroundUrl = null

  get backgroundDeclaration () {
    return `url(${this._backgroundUrl})`
  }

  @Mutation
  setBackgroundUrl (backgroundUrl) {
    this._backgroundUrl = backgroundUrl
  }
}

export default UIModule
